'use strict';

exports.__esModule = true;
exports.defineGlobalConfig = defineGlobalConfig;

var _merge = require('@kdocs/kdesign-vue/lib/utils/merge');

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = Object.create(null);

(0, _merge2.default)(config, {
  getPopperContainer: function getPopperContainer() {
    return document.body;
  }
});

function defineGlobalConfig(options) {
  (0, _merge2.default)(config, options || Object.create(null));
}

exports.default = config;